import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  menu: {
    '& .MuiList-root': {
      padding: '0'
    },

    '& .MuiListItem-root': {
      padding: '0 1rem'
    },

    '& .MuiMenuItem-root.Mui-focusVisible': {
      backgroundColor: 'transparent'
    },

    '& .MuiMenuItem-root:hover': {
      backgroundColor: '#F5F6F8'
    }
  }
}))

export default useStyles
